import styled from "styled-components";
import { ProgressBarWrapper } from "./ProgressBar";
import { Modal, ModalBody, ModalHeader } from "./Modal";

export const ScreenerModal = styled(Modal)`
  width: 100%;
  max-width: 600px;
  min-height: 480px;
  overflow: hidden;

  // Modal slide-in animation
  position: relative;
  @keyframes modalSlideIn {
    0% {
      bottom: -2000px;
    }
    100% {
      bottom: 0;
    }
  }
  animation: modalSlideIn 350ms forwards ease-out;
`;

export const ScreenerModalHeader = styled(ModalHeader)`
  display: flex;
  justify-content: flex-start;
  padding-left: 2em;
  padding-right: 2em;
  span:first-of-type {
    display: flex;
    align-items: center;
    div {
      padding: 0;
    }
    small {
      padding-left: 1em;
    }
  }
  ${ProgressBarWrapper} {
    margin: 0 -2em -1em;
  }
  @media (max-width: ${(p) => p.theme.breakpoints[500]}) {
    justify-content: center;
    padding-left: 0.75em;
    padding-right: 0.75em;
    span:first-of-type {
      flex-direction: column;
      small {
        padding-top: 0.5em;
      }
    }
  }
`;

export const ScreenerModalBody = styled(ModalBody)`
  justify-content: center;
  padding: 2em;
  min-height: 350px;
  input:focus,
  select:focus {
    box-shadow: 0 0 5px ${(props) => props.theme.colors.brand["700"]};
  }
  & > div {
    width: 100%;
  }
  @media (max-width: ${(p) => p.theme.breakpoints[500]}) {
    flex-grow: 1;
    max-height: initial;
    min-height: initial;
    padding: 0.75em;
  }

  // Content Nodes Styling
  form,
  .content-node__input,
  button,
  input,
  select {
    width: 100%;
  }
  form .content-node__row {
    height: 100%;
    gap: 12px;
    margin-top: 12px;
    & > button {
      max-height: 100%;
    }
  }
  h3,
  h4,
  h5 {
    color: ${(p) => p.theme.colors.brand[500]};
  }

  div:has(> form) {
    overflow-y: auto;
  }
`;
